





































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faSave, faTimes } from '@fortawesome/free-solid-svg-icons'
import constants from '@/utils/constants';
import { formatNumber } from '@/utils/helpers'

library.add(faBars, faSave, faTimes)

@Component({})
export default class PricePopup extends Vue {
  @Prop({ default: false }) showModal?: boolean;
  @Prop() data!: any;

  $swal: any;
  obj:any = {};

  get updateOrderDetail() {
    return this.$store.getters.GetUpdateOrderDetail;
  }

  @Watch('updateOrderDetail.isSuccess')
  watchOrderDetailSuccess() {
    if (this.updateOrderDetail.isSuccess) {
      const payload: any = {
        orderId: this.data.orderId,
        totalSales: this.obj.totalSales,
        paymentDetails: {
          ...this.data.paymentDetails,
          totalSales: formatNumber(this.obj.totalSales),
          totalTaxBase: formatNumber(this.obj.totalTaxBase),
          totalAmount: formatNumber(this.obj.totalAmount),
        },
      };
      if (this.data.discountName) {
        payload.paymentDetails.totalDiscount = formatNumber(this.obj.totalDiscount);
      }
      this.$store.commit('UPDATE_ORDER_DETAIL', payload);
      this.$emit('call-back', payload);
      this.$swal(
        constants.SUCCESS_MESSAGE,
        'Order Updated',
        constants.STATUS_SUCCESS
      );
    }
  }

  @Watch('updateOrderDetail.error')
  watchOrderDetailError() {
    if (this.updateOrderDetail.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderDetail.error,
        constants.STATUS_ERROR
      );
    }
  }

  removeDot(value) {
    return value.replace(/\./g, '');
  }

  reset() {
    this.obj = {
      totalTaxBase: this.removeDot(this.data.paymentDetails.totalTaxBase),
      totalAmount: this.removeDot(this.data.paymentDetails.totalAmount),
      totalDiscount: this.removeDot(this.data.paymentDetails.totalDiscount),
      totalSales: this.data.totalSales,
    };
  }

  discardModal() {
    this.reset();
    this.$emit('discard-modal');
  }

  saveData() {
    if (this.updateOrderDetail.isUpdating) return;
    this.$validator.validateAll().then(async(valid) => {
      if (valid) {
        const payload: any = {
          orderId: this.data.orderId,
          calculation: {
            totalSales: Number(this.obj.totalSales),
            totalTaxBase: Number(this.obj.totalTaxBase),
            totalAmount: Number(this.obj.totalAmount),
          },
        };
        if (this.data.discountName) {
          payload.calculation.totalDiscount = Number(this.obj.totalDiscount);
        }
        this.$store.dispatch('UpdateOrderDetail', payload);
      }
    })
  }
};
